﻿import { LiveDataSetStation, LiveDataSetValue, Status } from "../API/LiveData/LiveDataSet";
import { DefaultParameterDefinitions } from "../DefaultParameterDefinitions";
import { MainSite } from "../MainSite";
import { GetWarningThreshold, WarningGroup } from "../Model/WarningGroup";
import { ParameterGroupInfo, ParameterGroupInfoSet } from "../ParameterGroupInfoSet";
import { IStationValueFormatter, IStationValueObject } from "./IStationValueFormatter";

declare var sprintf;

export class DefaultGroupFormatter implements IStationValueFormatter {
    constructor(
        protected parameterGroup: ParameterGroupInfo,
        protected sensorId: string = undefined
    ) {
    }

    public getShortName(): string {
        return this.parameterGroup.ShortName;
    }

    public getUnits(): string {
        return MainSite.getUnitConverter().getConvertedUnits(this.parameterGroup.Units, this.parameterGroup.Id);
        return this.parameterGroup.Units;
    }

    public getParameterGroupInfo(): ParameterGroupInfo {
        return this.parameterGroup;
    }

    public getDescription(): string {
        return this.parameterGroup.Description;
    }

    public getId(): string {
        return this.parameterGroup.Id;
    }

    public getSensorId(): string | undefined {
        return this.sensorId;
    }

    public plottable(): boolean {
        if (typeof this.parameterGroup.Plottable == 'undefined') return true;

        return this.parameterGroup.Plottable;
    }

    public axisMin(): number {
        if (typeof this.parameterGroup.AxisMin == 'undefined') return null;

        return this.parameterGroup.AxisMin;
    }

    public axisMax(): number {
        if (typeof this.parameterGroup.AxisMax == 'undefined') return null;

        return this.parameterGroup.AxisMax;
    }

    public plotLines(): boolean {
        if (typeof this.parameterGroup.PlotLine == 'undefined') return true;

        return this.parameterGroup.PlotLine;
    }

    protected getLiveDataSetValue(
        liveDataSetStation: LiveDataSetStation
    ): LiveDataSetValue {

        var value: LiveDataSetValue = null;

        //console.log('')
        //console.log('liveDataSetStation.GroupValues:', liveDataSetStation.GroupValues)
        //console.log('this.parameterGroup.Id', this.parameterGroup.Id)
        //console.log('liveDataSetStation.GroupValues', liveDataSetStation.GroupValues)
        //console.log('this.sensorId', this.sensorId)
        //console.log('')

        if (liveDataSetStation?.GroupValues && this.parameterGroup.Id in liveDataSetStation.GroupValues) {
            if (this.sensorId) {
                if (!liveDataSetStation.GroupValues[this.parameterGroup.Id].some(_value => {
                    if (_value.Sensor == this.sensorId) {
                        value = _value;
                        return true;
                    }
                    return false;
                })) {
                    // a sensor id has been specified, but the group value is not present for this sensor
                    return null;
                }
            }
            else {
                value = liveDataSetStation.GroupValues[this.parameterGroup.Id][0];
            }
        }

        return value;
    }

    public format(
        liveDataSetStation: LiveDataSetStation,
        warningRules?: WarningGroup
    ): IStationValueObject {

        // the default if parameter has never existed
        var valueObject: IStationValueObject = {
            Value: '---',
            Status: null,
            WarningThreshold: null,
            ParameterDefinition: null,
            Sensor: null,
            Timestamp: null
        }

        const value = this.getLiveDataSetValue(liveDataSetStation);

        if (value == null) {
            return valueObject;
        }

        if (!MainSite.instance.staticDataManager.Schema.ParameterSchema.Stations[liveDataSetStation.Station.Id]
            .Sensors[value.Sensor]) {
            return valueObject;
        }

        var paramDef = MainSite.instance.staticDataManager.Schema.ParameterSchema
            ?.Stations?.[liveDataSetStation.Station.Id]
            ?.Sensors?.[value.Sensor]
            ?.Parameters?.[value.Parameter]
            ?.Variants?.[0]
            ?.ParameterDefinition;
        if ((!paramDef || paramDef.Default) && value.Parameter in DefaultParameterDefinitions.Parameters) {
            paramDef = DefaultParameterDefinitions.Parameters[value.Parameter];
        }

        // the default if parameter exists but has expired
        valueObject = {
            Value: '///',
            Status: value.ExpiryStatus,
            WarningThreshold: null,
            ParameterDefinition: paramDef,
            Timestamp: value.Timestamp,
            Sensor: value.Sensor
        }

        if (value.ExpiryStatus == Status.Expired) {
            return valueObject; // leave value as "///" if expired, don't bother checking warning rules
        }

        // console.info(`DefaultGroupFormatter.getConversionSet...`, this.parameterGroup.Units, this.parameterGroup);
        let unitsConversionSet = MainSite.getUnitConverter().getConversionSet(this.parameterGroup.Units, this.parameterGroup.Id);

        if (value.Value === null || value.Value === 'NIL') {
            // can be the case for cloud heights, etc
            valueObject.Value = '';

        } else if (typeof value.Value == 'number' && this.parameterGroup.Format) {
            // valueObject.Value = sprintf(this.parameterGroup.Format, MainSite.getUnitConverter().convert(value.Value, this.parameterGroup.Units, this.parameterGroup));
            if (unitsConversionSet) {
                if (this.parameterGroup == ParameterGroupInfoSet.Visibility_m) {
                    valueObject.Value = sprintf('%.2f', unitsConversionSet.convertValue(value.Value));
                } else {
                    valueObject.Value = sprintf(this.parameterGroup.Format, unitsConversionSet.convertValue(value.Value));
                }
            } else {
                valueObject.Value = sprintf(this.parameterGroup.Format, value.Value);
            }

            if (warningRules) {
                valueObject.WarningThreshold = GetWarningThreshold(warningRules, value.Value, this.parameterGroup, liveDataSetStation);
            }
        } else {
            valueObject.Value = (MainSite.getUnitConverter().convert(value.Value, this.parameterGroup.Units, this.parameterGroup.Id)).toString();
        }

        return valueObject;
    }
}